/* eslint-disable */
import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  FormHelperText,
} from '@mui/material';

const ETaxPopup = ({ open, onClose, onConfirm, language }) => {
  const [taxpayerType, setTaxpayerType] = useState('');
  const [name, setName] = useState('');
  const [taxId, setTaxId] = useState('');
  const [branchCode, setBranchCode] = useState('');
  const [address, setAddress] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (open) {
      // Reset all fields to empty values when the dialog is opened
      setTaxpayerType('');
      setName('');
      setTaxId('');
      setBranchCode('');
      setAddress('');
      setPostalCode('');
      setErrors({});
    }
  }, [open]);

  const handleTaxpayerTypeChange = (event) => {
    setTaxpayerType(event.target.value);
  };

  const handleConfirm = () => {
    const newErrors = {};
    if (!taxpayerType)
      newErrors.taxpayerType =
        language === 'TH'
          ? 'กรุณาเลือกประเภทผู้เสียภาษี'
          : 'Please select taxpayer type';
    if (!name)
      newErrors.name =
        language === 'TH'
          ? 'กรุณากรอกชื่อ - นามสกุล'
          : 'Please enter your full name';
    if (!taxId)
      newErrors.taxId =
        language === 'TH'
          ? 'กรุณากรอกเลขประจำตัวผู้เสียภาษีอากร'
          : 'Please enter taxpayer ID';
    if (!address)
      newErrors.address =
        language === 'TH' ? 'กรุณากรอกที่อยู่' : 'Please enter address';
    if (!postalCode)
      newErrors.postalCode =
        language === 'TH'
          ? 'กรุณากรอกรหัสไปรษณีย์'
          : 'Please enter postal code';
    if (taxpayerType === 'TXID') {
      if (!branchCode) {
        newErrors.branchCode =
          language === 'TH' ? 'กรุณากรอกรหัสสาขา' : 'Please enter branch code';
      } else if (branchCode.length !== 5) {
        newErrors.branchCode =
          language === 'TH'
            ? 'รหัสสาขาต้องมี 5 ตัวอักษร'
            : 'Branch code must be 5 characters';
      }
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const formData = {
      taxpayerType,
      name,
      taxId,
      branchCode,
      address,
      postalCode,
    };
    onConfirm(formData);
  };

  const handleTaxIdChange = (e) => {
    const value = e.target.value;
    if (value.length <= 13) {
      setTaxId(value);
      setErrors((prev) => ({ ...prev, taxId: '' }));
    }
  };

  const handlePostalCodeChange = (e) => {
    const value = e.target.value;
    if (value.length <= 5) {
      setPostalCode(value);
      setErrors((prev) => ({ ...prev, postalCode: '' }));
    }
  };

  const handleBranchNoChange = (e) => {
    const value = e.target.value;
    if (value.length <= 5) {
      setBranchCode(value);
      setErrors((prev) => ({ ...prev, branchCode: '' }));
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '15px',
          width: '600px', // Adjusted for better fit
        },
      }}
    >
      <DialogTitle>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            fontWeight: 'bold',
            fontSize: '20px',
            marginTop: '20px',
          }}
        >
          {language === 'TH' ? 'ใบกำกับภาษีอิเล็กทรอนิกส์' : 'E-Tax Invoice'}
        </Box>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ width: '100%', marginTop: '1px' }}>
          {/* ประเภทผู้เสียภาษี */}
          <Grid item xs={12}>
            <FormControl fullWidth size="small" error={!!errors.taxpayerType}>
              <InputLabel id="taxpayer-type-label">
                {language === 'TH' ? 'ประเภทผู้เสียภาษี' : 'Taxpayer Type'}
              </InputLabel>
              <Select
                labelId="taxpayer-type-label"
                id="taxpayer-type"
                label={
                  language === 'TH' ? 'ประเภทผู้เสียภาษี' : 'Taxpayer Type'
                }
                value={taxpayerType}
                onChange={handleTaxpayerTypeChange}
              >
                <MenuItem value="TXID">
                  {language === 'TH'
                    ? 'เลขประจำตัวผู้เสียภาษีอากรสำหรับนิติบุคล'
                    : 'Taxpayer ID for Legal Entities'}
                </MenuItem>
                <MenuItem value="NIDN">
                  {language === 'TH'
                    ? 'เลขประจำตัวผู้เสียภาษีอากรสำหรับบุคคลธรรมดา'
                    : 'Taxpayer ID for Individuals'}
                </MenuItem>
                <MenuItem value="CCPT">
                  {language === 'TH' ? 'เลขหนังสือเดินทาง' : 'Passport Number'}
                </MenuItem>
              </Select>
              {errors.taxpayerType && (
                <FormHelperText error>{errors.taxpayerType}</FormHelperText>
              )}
            </FormControl>
          </Grid>

          {/* ชื่อ - นามสกุล */}
          <Grid item xs={12}>
            <TextField
              label={language === 'TH' ? 'ชื่อ - นามสกุล' : 'Full Name'}
              variant="outlined"
              size="small"
              fullWidth
              value={name}
              onChange={(e) => {
                setName(e.target.value);
                setErrors((prev) => ({ ...prev, name: '' }));
              }}
              error={!!errors.name}
              helperText={errors.name}
            />
          </Grid>

          {/* เลขประจำตัวผู้เสียภาษีอากร */}
          <Grid item xs={12}>
            <TextField
              label={
                language === 'TH'
                  ? 'เลขประจำตัวผู้เสียภาษีอากร / เลขประจำตัวประชาชน / เลขหนังสือเดินทาง'
                  : 'Taxpayer ID / Citizen ID / Passport Number'
              }
              variant="outlined"
              type="number"
              size="small"
              fullWidth
              value={taxId}
              onChange={handleTaxIdChange}
              error={!!errors.taxId}
              helperText={errors.taxId}
            />
          </Grid>

          {/* รหัสสาขา */}
          {taxpayerType === 'TXID' && (
            <Grid item xs={12} md={6}>
              <TextField
                label={language === 'TH' ? 'รหัสสาขา' : 'Branch Code'}
                variant="outlined"
                type="number"
                size="small"
                fullWidth
                value={branchCode}
                onChange={handleBranchNoChange}
                error={!!errors.branchCode}
                helperText={errors.branchCode}
              />
            </Grid>
          )}

          {/* ที่อยู่ */}
          <Grid item xs={12}>
            <TextField
              id="outlined-multiline-static"
              label={language === 'TH' ? 'ที่อยู่' : 'Address'}
              multiline
              rows={4}
              variant="outlined"
              size="small"
              fullWidth
              value={address}
              onChange={(e) => {
                setAddress(e.target.value);
                setErrors((prev) => ({ ...prev, address: '' }));
              }}
              error={!!errors.address}
              helperText={errors.address}
              inputProps={{ maxLength: 255 }}
            />
          </Grid>

          {/* รหัสไปรษณีย์ */}
          <Grid item xs={12} md={6}>
            <TextField
              label={language === 'TH' ? 'รหัสไปรษณีย์' : 'Postal Code'}
              variant="outlined"
              type="number"
              size="small"
              fullWidth
              value={postalCode}
              onChange={handlePostalCodeChange}
              error={!!errors.postalCode}
              helperText={errors.postalCode}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            gap: 2,
            marginBottom: '20px',
          }}
        >
          <Button
            onClick={onClose}
            sx={{
              width: '100px',
              border: '1px solid',
              color: '#FC3A3A',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(252, 58, 58, 0.1)',
              },
            }}
          >
            {language === 'TH' ? 'ยกเลิก' : 'Cancel'}
          </Button>
          <Button
            onClick={handleConfirm}
            sx={{
              width: '100px',
              border: '1px solid',
              color: '#51D245',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(81, 210, 69, 0.1)',
              },
            }}
          >
            {language === 'TH' ? 'ยืนยัน' : 'Confirm'}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default ETaxPopup;
